import React, { useState, useEffect, useContext, useMemo } from 'react'
import Button from '../../atoms/Button/Button'
import { Clipboard, Customize } from '../../atoms/NewIcons/index'
import Datatable from '../../atoms/Datatable/Datatable'
import DatatableRowProdotto from '../DatatableRowProdotto/DatatableRowProdotto'
import InfoQuantita from '../../molecules/InfoQuantita/InfoQuantita'
import NewModal from '../../../components/molecules/NewModal/NewModal'
import _ from 'lodash'
import { api } from '../../../utils'
import { CHECKPERSONALIZZAZIONE, PERSONALIZZAZIONICARRELLO } from '../../../utils/endpoint'
import useTrans from '../../../hooks/useTrans'
import FormRadio from '../../atoms/FormRadio/FormRadio'
import { Trans } from '../../../components/atoms'
import { ProdottoContext } from '../../../context/ProdottoContext'
import {
  getIgnoraMinimiStampa,
  showColonnaQuantita,
  showRiepilogo,
} from '../../../utils/servicegift'
import { useSelector } from 'react-redux'
import { trackingGAEventProdotto } from '../../../utils/gtm'
import { ChipCloseFilter, ChipMultipleDropdown } from '../../atoms/Chip/Chip'
import NoFornitoreModal from '../../organisms/NoFornitoreModal/NoFornitoreModal'
import { getMaxQuantitaOrdinabileLeadTime, isQuantitaValidLeadTime } from '../../../utils/leadtime'

const TableSchedaProdotto = ({
  selectedArticolo,
  showSelectorTaglia,
  showSelectorColore,
  prodotto,
  AddToCart,
  showPersonalizzaForm,
  setShowPersonalizzaForm,
  articoliQuantita,
  isValid,
  handleQuantita,
  onChangeInputQuantita,
  disabled,
  service_gift,
  quantita,
  OnClickRichiedi,
  utente,
  personalizzazioni,
  leadTimePersonalizzazioni,
  handleVisualizzaImballi,
}) => {
  const t = useTrans()
  const isAs400Down = useSelector((state) => state.servicegift.as400_down)
  const [personalizzazioniDisponibili, setPersonalizzazioniDisponibili] = useState(null)

  const selectedArticoloColore = useMemo(() => {
    return selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 7)?.[0]
  }, [selectedArticolo])

  const selectedArticoloTaglia = useMemo(() => {
    return selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 8)?.[0]
  }, [selectedArticolo])

  const {
    showDuplicaPersonalizzazione,
    setShowDuplicaPersonalizzazione,
    setShowQuantitaInsufficiente,
  } = useContext(ProdottoContext)
  const [showNoFornitoreModal, setShowNoFornitoreModal] = useState(false)

  const CheckErroreEscluso = (codice_articolo) => {
    const articolo = quantita.filter((articolo) => articolo?.codice === codice_articolo)[0]
    return articolo?.escludi_da_listino_di_stampa && articolo.quantita > 0
      ? {
          error:
            "Questo articolo non può essere personalizzato, rimuovi l'articolo per proseguire con la personalizzazione",
        }
      : null
  }

  const CheckPersonalizzazione = async (prodotto) => {
    const params = {
      prodotto_id: prodotto.id,
    }
    await api.get(CHECKPERSONALIZZAZIONE, { params }).then((response) => {
      response.data && setPersonalizzazioniDisponibili(_.uniqBy(response.data?.pers, 'id'))
      response?.data?.pers?.length > 0
        ? showPersonalizzaForm
          ? null
          : setShowDuplicaPersonalizzazione(true)
        : setShowPersonalizzaForm(true)
    })
  }

  const _handleSubmit = () => {
    AddToCart(articoliQuantita)
  }

  const _withInchiostro =
    prodotto?.articoli
      ?.map((articolo) =>
        articolo?.attributi_lista?.filter((attributo) => attributo?.attributo === 6)
      )
      .filter((result) => result?.length > 0).length > 0
      ? true
      : false

  const n_cols = _.omit(
    prodotto.taglie.length > 0 ? cols : colsMenoTaglia,
    showColonnaQuantita(utente, service_gift) ? [] : ['quantita']
  )

  const [selectedColori, setSelectedColori] = useState([])
  const [selectedTaglie, setSelectedTaglie] = useState([])

  const colorOptions = prodotto.colori.map((colore) => ({
    value: colore.id,
    label: colore.nome,
    ...colore,
  }))

  // Taglie disponibili in base ai colori selezionati
  const tagliaOptions = prodotto.taglie.map((taglia) => ({
    value: taglia.id,
    label: taglia.nome,
    ...taglia,
  }))

  // Articoli filtrati
  const filteredArticoli = useMemo(() => {
    let articoli = prodotto.articoli
    if (selectedColori.length > 0) {
      articoli = articoli.filter((a) =>
        a.attributi_lista.some(
          (attr) => attr.attributo === 7 && selectedColori.some((c) => c.id === attr.id)
        )
      )
    }
    if (selectedTaglie.length > 0) {
      articoli = articoli.filter((a) =>
        a.attributi_lista.some(
          (attr) => attr.attributo === 8 && selectedTaglie.some((t) => t.id === attr.id)
        )
      )
    }
    return articoli
  }, [prodotto.articoli, selectedColori, selectedTaglie])

  const quantitaTotale = useMemo(() => {
    return quantita
      ?.filter((item) => item?.escludi_da_listino_di_stampa !== true)
      ?.reduce((acc, curr) => acc + (curr.quantita || 0), 0)
  }, [quantita])

  useEffect(() => {
    if (!isValid && showPersonalizzaForm) {
      setShowPersonalizzaForm(false)
    }
  }, [isValid, showPersonalizzaForm])

  return (
    <>
      <InfoQuantita
        prodotto={prodotto}
        service_gift={service_gift}
        articolo={selectedArticolo}
        personalizzazioni={personalizzazioni}
        imballi={selectedArticolo?.imballi}
        sotto_imballi={selectedArticolo?.sotto_imballi}
        handleVisualizzaImballi={handleVisualizzaImballi}
      />

      <div className="table-scheda-prodotto__filters">
        {selectedArticoloColore &&
          (showSelectorColore ? (
            colorOptions.length > 1 && (
              <ChipMultipleDropdown
                options={colorOptions}
                value={selectedColori.map((c) => c.id)}
                setValue={(ids) =>
                  setSelectedColori(colorOptions.filter((opt) => ids.includes(opt.value)))
                }
                multiple={true}
                placeholder={t('Filtra per colore')}
              />
            )
          ) : (
            <p className="table-scheda-prodotto__filter">
              <Trans chiave="Colore" />:{' '}
              <span className="table-scheda-prodotto__filter">{selectedArticoloColore.nome}</span>
            </p>
          ))}
        {selectedArticoloTaglia &&
          (showSelectorTaglia ? (
            tagliaOptions.length > 1 && (
              <ChipMultipleDropdown
                options={tagliaOptions}
                value={selectedTaglie.map((c) => c.id)}
                setValue={(ids) =>
                  setSelectedTaglie(tagliaOptions.filter((opt) => ids.includes(opt.value)))
                }
                multiple={true}
                placeholder={t('Filtra per taglia')}
              />
            )
          ) : (
            <p className="table-scheda-prodotto__filter">
              <Trans chiave="Taglia" />:{' '}
              <span className="table-scheda-prodotto__filter">{selectedArticoloTaglia.nome}</span>
            </p>
          ))}
      </div>

      {(!!selectedColori?.length || !!selectedTaglie.length) && (
        <div className="table-scheda-prodotto__filters__selected">
          <>
            {selectedColori.map((colore) => (
              <ChipCloseFilter
                key={`colore-${colore.id}`}
                size="sm"
                backgroundVariant="primary"
                placeholder={
                  <>
                    {t('Colore')}: <strong>{colore.nome}</strong>
                  </>
                }
                onClose={() => setSelectedColori((prev) => prev.filter((c) => c.id !== colore.id))}
              />
            ))}
            {selectedTaglie.map((taglia) => (
              <ChipCloseFilter
                key={`taglia-${taglia.id}`}
                size="sm"
                backgroundVariant="primary"
                placeholder={
                  <>
                    {t('Taglia')}: <strong>{taglia.nome}</strong>
                  </>
                }
                onClose={() => setSelectedTaglie((prev) => prev.filter((t) => t.id !== taglia.id))}
              />
            ))}
          </>
        </div>
      )}

      <Datatable cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}>
        <div className="u-scrollable table-scheda-prodotto">
          {filteredArticoli.map((articolo, i) => (
            <DatatableRowProdotto
              ErroreEscludiListinoDiStampa={CheckErroreEscluso(articolo?.codice)}
              articolo={articolo}
              cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}
              id={articolo.id}
              key={i}
              index={i}
              inchiostro={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 6)[0]?.nome
              }
              taglia={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 8)[0]?.nome
              }
              colore={
                articolo?.attributi_lista?.filter((attributo) => attributo.attributo === 7)[0]
              }
              isFirstElement={false}
              multipli={articolo.acquistabile_multipli}
              prezzo={
                articolo?.con_fasce && articolo?.fasce[articolo?.fasce.length - 1]?.prezzo
                  ? articolo?.fasce[articolo?.fasce.length - 1].prezzo
                  : articolo.prezzo
              }
              imballi={selectedArticolo?.imballi}
              sotto_imballi={selectedArticolo?.sotto_imballi}
              disponibilita={articolo.disponibilita}
              quantita_reale_magazzino={articolo.quantita_reale_magazzino}
              disponibilita_reale_maggiore={articolo.disponibilita_reale_maggiore}
              disponibilita_in_opzione={articolo.disponibilita_in_opzione}
              data_in_opzione={articolo.data_in_opzione}
              codice={articolo?.codice}
              prossimi_arrivi={articolo.prossimi_arrivi}
              onChangeInputQuantita={onChangeInputQuantita}
              handleQuantita={handleQuantita}
              OnClickRichiedi={OnClickRichiedi}
              service_gift={service_gift}
              image={articolo?.main_image}
            ></DatatableRowProdotto>
          ))}
        </div>
      </Datatable>
      {showRiepilogo(utente, service_gift, isAs400Down) && (
        <div className="table-scheda-prodotto__buttons">
          <Button
            disabled={!isValid}
            icon={<Clipboard />}
            icon_pos="left"
            size="medium"
            label={
              service_gift && !service_gift.personalizzazione
                ? t('Aggiungi')
                : t('Aggiungi senza stampa')
            }
            variant="secondary"
            onClick={() => {
              _handleSubmit()
              setShowPersonalizzaForm(false)
            }}
          />
          {(!service_gift || service_gift.personalizzazione) &&
            prodotto?.personalizzabile &&
            personalizzazioni?.tecniche?.length > 0 && (
              <Button
                disabled={!isValid || showPersonalizzaForm}
                icon={<Customize />}
                icon_pos="left"
                size="medium"
                label={t('Personalizza i tuoi prodotti')}
                variant="primary-gradient"
                onClick={() => {
                  // ! funzione che calcola la quantità minima personalizzabile se è soddisfatta
                  if (prodotto?.personalizzabile) {
                    if (
                      quantitaTotale < prodotto?.quantita_minima_personalizzabile &&
                      !getIgnoraMinimiStampa(utente, service_gift)
                    ) {
                      setShowQuantitaInsufficiente(true)
                      return
                    }

                    if (!isQuantitaValidLeadTime(leadTimePersonalizzazioni)) {
                      setShowNoFornitoreModal(true)
                      return
                    }

                    CheckPersonalizzazione(prodotto)
                  }
                }}
              />
            )}
          <DuplicaPersonalizzazioneModal
            personalizzazioniDisponibili={personalizzazioniDisponibili}
            setShowPersonalizzaForm={setShowPersonalizzaForm}
            isVisible={showDuplicaPersonalizzazione}
            setVisible={setShowDuplicaPersonalizzazione}
            AddToCart={AddToCart}
            prodotto={prodotto}
          />
          <NoFornitoreModal
            isVisible={showNoFornitoreModal}
            onClose={setShowNoFornitoreModal}
            // tecnica={selectedTecnica}
            maxQuantita={
              getMaxQuantitaOrdinabileLeadTime(leadTimePersonalizzazioni)?.max_quantita_ordinabile
            }
          />
        </div>
      )}
    </>
  )
}

const DuplicaPersonalizzazioneModal = ({
  personalizzazioniDisponibili,
  setShowPersonalizzaForm,
  isVisible,
  setVisible,
  AddToCart,
  prodotto,
}) => {
  const t = useTrans()

  const [selected, setSelected] = useState(null)
  const [step, setStep] = useState(0)
  const [posizione, setPosizione] = useState()

  useEffect(() => {
    setStep(0)

    return () => {
      setStep(0)
    }
  }, [])

  const handleNome = (obj) => {
    const nome = obj?.toString().split('_')
    const numero_max = personalizzazioniDisponibili
      ?.filter((item) => item?.nome_lavorazione?.split('_')[0] === nome[0])
      ?.reduce(
        (prev, curr) => {
          const value = curr?.nome_lavorazione?.split('_')[1] || 0
          return Math.max(prev, parseInt(value))
        },
        [0]
      )
    const new_nome = nome[0] + '_' + (parseInt(numero_max) + 1)
    return new_nome
  }

  const handleSubmit = () => {
    const createNew = selected?.posizioni?.length > 1 && posizione < 2 ? true : false
    const Personalizzazione = { ...selected }
    const PersonalizzazioneSelezionata = createNew ? selected?.posizioni[posizione] : undefined
    const PersonalizzazioneModificata = createNew
      ? _.set(Personalizzazione, 'posizioni', [PersonalizzazioneSelezionata])
      : undefined

    const nome = handleNome(
      PersonalizzazioneModificata?.nome_lavorazione
        ? PersonalizzazioneModificata?.nome_lavorazione
        : selected?.nome_lavorazione
    )
    const params = PersonalizzazioneModificata
      ? {
          nome_lavorazione: nome,
          riconfezionamento: PersonalizzazioneModificata?.confezionamento_richiesto,
          posizioni: PersonalizzazioneModificata?.posizioni?.map((posizione) => ({
            ...posizione,
            logo_file_id: posizione?.logo_file,
          })),
        }
      : undefined
    createNew
      ? api
          .post(`${PERSONALIZZAZIONICARRELLO}`, params)
          .then((response) => {
            AddToCart(null, response.data.id)
            setStep(0)
            setVisible(false)
          })
          .catch((err) => setVisible(false))
      : (AddToCart(null, selected?.id), setStep(0), setVisible(false))
  }
  return (
    <NewModal
      visible={isVisible}
      title={t('Desideri duplicare la personalizzazione?')}
      text={t(
        'Le seguenti personalizzazioni salvate possono essere applicate alle referenze da te selezionate'
      )}
      onClose={() => setVisible(false)}
      actions={[
        <Button
          label={step > 0 ? t('Indietro') : t('Crea nuova personalizzazione')}
          variant="secondary"
          size="medium"
          onClick={() => {
            if (step === 0) {
              setShowPersonalizzaForm(true)
              setVisible(false)
              const first_articolo = prodotto?.articoli.length > 0 ? prodotto?.articoli[0] : null
              trackingGAEventProdotto(
                'duplicate_customization',
                'nessun_posizione',
                'crea_nuova',
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
            } else {
              setStep(0)
              setPosizione(null)
            }
          }}
        />,
        <Button
          label={step > 0 ? t('Duplica Personalizzazione') : t('Procedi')}
          variant="primary"
          disabled={
            step === 0 ? (selected === null ? true : false) : posizione === null ? true : false
          }
          size="medium"
          onClick={() => {
            if (step === 0) setStep(1)
            else {
              const first_articolo = prodotto?.articoli.length > 0 ? prodotto?.articoli[0] : null
              let pos = ''
              if (posizione === 0) pos = 'posizione_1'
              else if (posizione === 1) pos = 'posizione_2'
              else if (posizione === 2) pos = 'entrambe'
              trackingGAEventProdotto(
                'duplicate_customization',
                pos,
                'applica',
                first_articolo?.titolo || '',
                prodotto?.codice || ''
              )
              handleSubmit()
            }
          }}
        />,
      ]}
    >
      {step === 0 ? (
        <div
          style={{ margintop: 20, maxHeight: 450, overflowY: 'auto', textAlign: 'left' }}
          className="u-scrollable"
        >
          {personalizzazioniDisponibili?.map((item) => (
            <div style={{ margin: '5px 0px' }} key={`duplica-personalizzazione-${item?.id}`}>
              <FormRadio
                key={item?.id}
                label={item?.nome_lavorazione}
                checked={selected?.id === item?.id}
                onClick={() => setSelected(item)}
              />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ margintop: 20, textAlign: 'left' }}>
          <p style={{ textTransform: 'uppercase', marginBottom: 10, color: '' }}>
            <strong>
              {t('Applica')} {selected?.nome_lavorazione}
            </strong>
          </p>
          <FormRadio
            checked={posizione === 0}
            label={t('A Posizione 1')}
            onClick={() => setPosizione(0)}
          />
          {selected?.posizioni?.length > 1 && (
            <>
              <FormRadio
                checked={posizione === 1}
                label={t('A Posizione 2')}
                onClick={() => setPosizione(1)}
              />
              <FormRadio
                checked={posizione === 2}
                label={t('A entrambe le posizioni')}
                onClick={() => setPosizione(2)}
              />
            </>
          )}
        </div>
      )}
    </NewModal>
  )
}

export default TableSchedaProdotto

export const cols = {
  codice: { label: <Trans chiave="Codice" />, grow: 2, mobileCols: 4 },
  colore: { label: <Trans chiave="Colore" />, mobileCols: 4 },
  inchiostro: { label: <Trans chiave="Inchiostro" />, mobileCols: 2, grow: 2 },
  taglia: { label: <Trans chiave="Taglia" />, mobileCols: 4 },
  prezzo: { label: <Trans chiave="Prezzo" />, mobileCols: 6, mobileOrder: 'end' },
  disponibilita: {
    label: <Trans chiave="Disponibilità" />,
    info: (
      <Trans chiave="Disponibilità attuale dei prodotti e visualizzazione dei prossimi arrivi" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  prossimi_arrivi: {
    label: <Trans chiave="Prossimi arrivi" />,
    info: (
      <Trans chiave="Nel caso di non disponibilità dell' articolo, è possibile ordinarlo su un prossimo arrivo (le date indicate sono valide solo se di colore verde)" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  quantita: { label: <Trans chiave="Quantità" />, mobileCols: 12, grow: 2, mobileOrder: 'end' },
}

export const colsMenoTaglia = {
  codice: { label: <Trans chiave="Codice" />, grow: 2, mobileCols: 4 },
  colore: { label: <Trans chiave="Colore" />, mobileCols: 4 },
  inchiostro: { label: <Trans chiave="Inchiostro" />, mobileCols: 2, grow: 2 },
  prezzo: { label: <Trans chiave="Prezzo" />, mobileCols: 6, mobileOrder: 'end' },
  disponibilita: {
    label: <Trans chiave="Disponibilità" />,
    info: (
      <Trans chiave="Disponibilità attuale dei prodotti e visualizzazione dei prossimi arrivi" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  prossimi_arrivi: {
    label: <Trans chiave="Prossimi arrivi" />,
    info: (
      <Trans chiave="Nel caso di non disponibilità dell' articolo, è possibile ordinarlo su un prossimo arrivo (le date indicate sono valide solo se di colore verde)" />
    ),
    mobileCols: 6,
    grow: 2,
  },
  quantita: { label: <Trans chiave="Quantità" />, mobileCols: 12, grow: 2, mobileOrder: 'end' },
}
